import React, { useEffect, useState } from "react"
import { InputGroup, Form, FormControl } from "react-bootstrap"
import sort from "./sort"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTrash } from "@fortawesome/free-solid-svg-icons"
import keyEnterConfirm from "./keyEnterConfirm"

export default function MultiFilterQuery(props) {
    const [col, setCol] = useState([])
    const [filtros, setFiltros] = useState({})

    const handleChangeSelect = e => {
        setFiltros(prev => ({
            ...prev,
            [e.target.value]: ''
        }))
    }

    const handleChangeInput = e => {
        setFiltros(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const borrarFiltro = key => {
        delete filtros[key]

        setFiltros({ ...filtros })
    }

    const tipoFiltro = (columna, key) => {
        switch (columna.tipo) {
            case 'texto':
                return <FormControl
                    id='form-filter'
                    disabled={!key}
                    type="text"
                    placeholder="Buscar"
                    name={key}
                    value={filtros[key]}
                    onChange={handleChangeInput}
                    onKeyUp={e => keyEnterConfirm(e, props.accion)}
                />

            case 'fecha':
                return <FormControl
                    id='form-filter'
                    type="date"
                    name={key}
                    value={filtros[key]}
                    onChange={handleChangeInput}
                    onKeyUp={e => keyEnterConfirm(e, props.accion)}
                />
        
            default:
                return <FormControl
                    id='form-filter'
                    disabled={!key}
                    type="text"
                    placeholder="Buscar"
                    name={key}
                    value={filtros[key]}
                    onChange={handleChangeInput}
                    onKeyUp={e => keyEnterConfirm(e, props.accion)}
                />
        }
    }

    useEffect(() => {
        if (props.columnas !== undefined) {
            const c = props.columnas.slice(0).sort((a, b) => sort.alfAsc(a, b, 'label'))

            setCol(c)
        } else {
            setCol([])
        }

    }, [JSON.stringify(props.col)])

    useEffect(() => {
        const multiFiltros = Object.keys(filtros).map(key => {
            return {
                tipo: col.find(c => c.key === key).tipo,
                key,
                values: { value: filtros[key] }
            }
        })
        props.setFiltros(multiFiltros)
    }, [filtros])

    return (
        <>
            <InputGroup>
                <InputGroup.Text>Buscar por...</InputGroup.Text>
                <Form.Control
                    id="form-filter-select"
                    as="select"
                    defaultValue=""
                    onChange={handleChangeSelect}
                >
                    <option value=''>Seleccione una columna</option>
                    {col.map(c => <option key={c.key} value={c.key} >{c.label}</option>)}
                </Form.Control>
            </InputGroup>

            <div className="text-muted">
                *Puede buscar varios valores, si los separa por coma.
                <br />
            </div>

            {Object.keys(filtros).map(key => <>
                <InputGroup>
                    <InputGroup.Text>
                        <FontAwesomeIcon className="cursor-pointer" onClick={() => borrarFiltro(key)} icon={faTrash} color="red" />{' - '}
                        {col.find(c => c.key === key).label}
                    </InputGroup.Text>
                    { tipoFiltro(col.find(c => c.key === key), key) }
                </InputGroup>
            </>)}
        </>
    )
}